import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { storesApi } from "../api";
import { showToast } from "../../../../utils/showToast";

export const SET_LOADING = "saga/users/SET_LOADING";
export const SET_UPDATE_LOADING = "saga/users/SET_UPDATE_LOADING";
export const SET_ACTIONS_LOADING = "saga/users/SET_ACTIONS_LOADING";

export const ADD_STORE = "saga/users/ADD_STORE";
export const ADD_STORE_SUCCESS = "saga/users/ADD_STORE_SUCCESS";

export const EDIT_STORE = "saga/users/EDIT_STORE";
export const EDIT_STORE_SUCCESS = "saga/users/EDIT_STORE_SUCCESS";

export const DELETE_STORE = "saga/users/DELETE_STORE";

export const RECALCULATE_STORE = "saga/users/RECALCULATE_STORE";

export const FETCH_SETTINGS = "saga/users/FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "saga/users/FETCH_SETTINGS_SUCCESS";

export const FETCH_STORES = "saga/users/FETCH_STORES";
export const FETCH_STORES_SUCCESS = "saga/users/FETCH_STORES_SUCCESS";

export const FETCH_ACTIONS = "saga/users/FETCH_ACTIONS";
export const FETCH_ACTIONS_SUCCESS = "saga/users/FETCH_ACTIONS_SUCCESS";

export const RESET_STATUS = "saga/users/RESET_STATUS";
export const SET_ERROR = "saga/users/SET_ERROR";
export const SET_STATUS = "saga/users/SET_STATUS";

const actionCreators = {
  fetchSettings: createAction(FETCH_SETTINGS),
  fetchStores: createAction(FETCH_STORES),
  fetchActions: createAction(FETCH_ACTIONS),
  createStore: createAction(ADD_STORE),
  changeStore: createAction(EDIT_STORE),
  deleteStore: createAction(DELETE_STORE),
  recalculate: createAction(RECALCULATE_STORE),
  resetStatus: createAction(RESET_STATUS)
};

export const {
  fetchSettings,
  fetchActions,
  createStore,
  changeStore,
  deleteStore,
  resetStatus,
  recalculate
} = actionCreators;

export default function* watchUsers() {
  yield takeLatestSafe(FETCH_SETTINGS, getSettings);
  yield takeLatestSafe(FETCH_STORES, getStores);
  yield takeLatestSafe(FETCH_ACTIONS, getActions);
  yield takeLatestSafe(ADD_STORE, addStore);
  yield takeLatestSafe(DELETE_STORE, removeStore);
  yield takeLatestSafe(RECALCULATE_STORE, recalculateStore);
  yield takeLatestSafe(EDIT_STORE, editStore);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getSettings() {
  yield put({ type: SET_LOADING, payload: true });

  const { data } = yield call(storesApi.getSettings);

  yield put({
    type: FETCH_SETTINGS_SUCCESS,
    payload: data
  });

  yield put({ type: SET_LOADING, payload: false });
  yield getStores();
}

function* getStores() {
  yield put({ type: SET_UPDATE_LOADING, payload: true });

  const res = yield call(storesApi.getStores);
  yield put({
    type: FETCH_STORES_SUCCESS,
    payload: { stores: res.data }
  });

  yield put({ type: SET_UPDATE_LOADING, payload: false });
}

function* getActions({ payload }) {
  yield put({ type: SET_ACTIONS_LOADING, payload: true });

  const { data } = yield call(storesApi.getStoreDetailsWithActions, { id: payload });

  yield put({
    type: FETCH_ACTIONS_SUCCESS,
    payload: data
  });

  yield put({ type: SET_ACTIONS_LOADING, payload: false });
}

function* addStore({ payload: data }) {
  yield put({ type: SET_STATUS, payload: "pending" });
  let { clubready_chain_id, ...rest } = data;

  let clubready_store = {
    ...rest,
    organization_id: Number(data.organization_id.id),
    remote_uid: Number(data.remote_uid),
    ...(!data.without_chain && {
      clubready_chain_id: Number(clubready_chain_id.id)
    })
  };

  yield call(storesApi.createStore, { clubready_store });

  yield put({ type: SET_STATUS, payload: "success" });
}

function* editStore({ payload: { data, id, orgName, organizationId } }) {
  yield put({ type: SET_STATUS, payload: "pending" });
  let res = yield call(storesApi.updateStore, id, {
    clubready_store: data
  });

  yield put({
    type: EDIT_STORE_SUCCESS,
    payload: { id, data: res.data, orgName, organizationId }
  });
}

function* removeStore({ payload }) {
  try {
    let res = yield call(storesApi.removeStore, payload.id);

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}

function* recalculateStore({ payload }) {
  try {
    const apiMethod = payload.reimport
      ? storesApi.reimportAndRecalculateStore
      : storesApi.recalculateStore;

    const res = yield call(apiMethod, { id: payload.id.toString() });

    if (res.status === 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.error(err);
    showToast(err?.response?.data?.error || "Unexpected error");
  }
}
